import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { Button } from 'reactstrap'
// import { appRootPathPrefix } from '../../config'
import { history } from '../../redux/history'
import { identityServices, Loader } from '../common'
import { CaseFieldForm } from './component'
class CaseFieldComponent1 extends Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: false,
			formValue: {},
			showIn: {
				create: {
					position: 3,
					screenCol: 1,
				},
				detail: {
					position: 3,
					screenCol: 1,
				},
				result: {
					sort: {
						order: 'asc',
					},
					position: 6,
					displayCol: 3,
				},
				search: {
					position: 2,
				},
			},
			sectionMap: [
				{ name: 'General Info', screenCol: 1 },
				{ name: 'Other Info', screenCol: 2 },
				{ name: 'Status', screenCol: 2 },
			],
		}
	}
	async componentDidMount() {
		let props = this.props
		let { t } = props
		if (props && props.params && props.params.itemId) {
			this.setState({ loading: true })
			await this.props.getOne({ filter: [{ name: 'id', value: props.params.itemId }], t })
		}
	}

	componentWillReceiveProps(props) {
		const { entity } = props
		if (entity && entity.entityValues && typeof entity.entityValues === 'object') this.setState({ formValue: entity.entityValues, loading: entity.loading })
	}
	executeRefApi = async options => {
		const requestOptions = {
			method: `${options.method || 'GET'}`,
			headers: { 'Content-Type': 'application/json', clientApp: window.location.pathname.split('/')[1] },
			url: `${options.url}`,
		}
		// @ts-ignore
		let response = await identityServices.identityApi.request(requestOptions)
		if (response && response.data) return response.data
		else return false
	}

	toCamelCase = str => {
		return str.replace(/^([A-Z])|\s(\w)/g, function (match, p1, p2, offset) {
			if (p2) return p2.toUpperCase()
			return p1.toLowerCase()
		})
	}
	typeModal(item) {
		const {
			meta: { contentMeta },
		} = this.props
		if (contentMeta && contentMeta[item]) return contentMeta[item]
	}
	validateItems(formValues) {
		if (formValues && formValues.fieldProperties && formValues.fieldProperties.options) {
			let properties = formValues.fieldProperties.options
			try {
				properties = properties && typeof properties === 'string' ? JSON.parse(properties) : properties
				properties.isStatic = parseInt(formValues.fieldProperties.isStatic) || 0
				formValues.fieldProperties.options = properties
				return formValues
			} catch (err) {
				return { error: { options: `Syntax Error ${err}` } }
			}
		}
		return null
	}
	mapProps(item) {
		const { showIn, listMap, sectionMap } = this.state
		if (item && item.fieldProperties && !item.fieldProperties.showIn) item.fieldProperties.showIn = showIn || {}

		item.fieldProperties.display = true
		item.fieldProperties.required =item.fieldProperties.required?JSON.parse(item.fieldProperties.required) : false

		if (item && item.fieldProperties && item.fieldProperties.showIn && item.fieldProperties.position) {
			item.fieldProperties.showIn.create.position = parseInt(item.fieldProperties.position)
			item.fieldProperties.showIn.detail.position = parseInt(item.fieldProperties.position)
		}

		if (item && item.fieldProperties && item.fieldProperties.sectionName) {
			let col = sectionMap && sectionMap.find(x => x.name === item.fieldProperties.sectionName)
			item.fieldProperties.showIn.create.screenCol = col.screenCol
			item.fieldProperties.showIn.detail.screenCol = col.screenCol
		}

		return item
	}
	onSubmit(item) {
		let { t } = this.props
		if (item) {
			let value = this.mapProps(item)
			setTimeout(() => {
				this.props.upsertItem({ entityValues: value, t, itemType: 'default' })
			}, 200)
			this.setState({ loading: true })
		} else this.setState({ loading: false })
	}
	back() {
		history.goBack()
	}
	render() {
		const { t } = this.props
		const { loading, formValue } = this.state
		return (
			<div className="animated fadeIn">
				<div className="main-section">
					<div className="main-inner">
						{loading && <Loader />}
						<div className="common-heading">
							<div className="row table-title">
								<div className="col-sm-6">
									<div className="heading">
										<h5>{t('Case Field')}</h5>
									</div>
								</div>
								<div className="col-sm-6">
									<Button color="link" className="pull-right" onClick={e => history.goBack()}>
										{t('Back to List')}
									</Button>
								</div>
							</div>
						</div>
						<section>
							<CaseFieldForm
								meta={this.props.meta}
								executeRefApi={this.executeRefApi}
								toCamelCase={this.toCamelCase}
								typeModal={this.typeModal.bind(this)}
								validateItems={this.validateItems}
								onSubmit={this.onSubmit.bind(this)}
								formValue={formValue}
							/>
						</section>
					</div>
				</div>
			</div>
		)
	}
}
export const CaseFieldComponent = withTranslation()(CaseFieldComponent1)
